<template>
  <div>
  <!-- Page Title-->
    <div class="page-title">
      <div class="container">
        <h1>Shipping</h1>
        <ul class="breadcrumbs">
          <li><router-link to="/home">Home</router-link>
          </li>
          <li class="separator">&nbsp;/&nbsp;</li>
          <li>Shipping</li>
        </ul>
      </div>
    </div>
    <!-- Page Content-->
    <div class="container padding-bottom-3x mb-2">
      <div class="row">
        <!-- Checkout Shipping-->
        <div class="col-xl-9 col-lg-8">
          <div class="steps flex-sm-nowrap mb-5"><router-link class="step" to="/checkout">
              <h4 class="step-title"><i class="material-icons check_circle"></i>1. Address</h4></router-link>
              <router-link class="step active" to="/checkout">
              <h4 class="step-title">2. Shipping</h4></router-link><router-link class="step" to="/payment">
              <h4 class="step-title">3. Payment</h4></router-link><router-link class="step" to="/checkout">
              <h4 class="step-title">4. Review</h4></router-link></div>
          <h4>Choose Shipping Method</h4>
          <hr class="padding-bottom-1x">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead class="thead-default">
                <tr>
                  <th></th>
                  <th>Shipping method</th>
                  <th>Delivery time</th>
                  <th>Handling fee</th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td class="align-middle">
                    <div class="custom-control custom-radio mb-0">
                      <input class="custom-control-input" type="radio" id="local" name="shipping-method" checked>
                      <label class="custom-control-label" for="local"></label>
                    </div>
                  </td>
                  <td class="align-middle"><span class="text-medium">Local Shipping</span><br><span class="text-muted text-sm">All Addresses(default zone), United States & Canada</span></td>
                  <td class="align-middle">1 - 2 days </td>
                  <td class="align-middle">$0.00</td>
                </tr>
                <tr>
                  <td class="align-middle">
                    <div class="custom-control custom-radio mb-0">
                      <input class="custom-control-input" type="radio" id="flat" name="shipping-method">
                      <label class="custom-control-label" for="flat"></label>
                    </div>
                  </td>
                  <td class="align-middle"><span class="text-medium">Fast mail</span><br><span class="text-muted text-sm">All Addresses(default zone)</span></td>
                  <td class="align-middle">1 - 2 days</td>
                  <td class="align-middle">$0.00</td>
                </tr>
                <tr>
                  <td class="align-middle">
                    <div class="custom-control custom-radio mb-0">
                      <input class="custom-control-input" type="radio" id="ups" name="shipping-method">
                      <label class="custom-control-label" for="ups"></label>
                    </div>
                  </td>
                  <td class="align-middle"><span class="text-medium">UPS Shipping</span><br><span class="text-muted text-sm">All Addresses(default zone)</span></td>
                  <td class="align-middle">1 - 2 days</td>
                  <td class="align-middle">$0.00</td>
                </tr>
                <tr>
                  <td class="align-middle">
                    <div class="custom-control custom-radio mb-0">
                      <input class="custom-control-input" type="radio" id="pickup" name="shipping-method">
                      <label class="custom-control-label" for="pickup"></label>
                    </div>
                  </td>
                  <td class="align-middle"><span class="text-medium">Local Pickup from store</span><br><span class="text-muted text-sm">All Addresses(default zone)</span></td>
                  <td class="align-middle">&mdash;</td>
                  <td class="align-middle">$0.00</td>
                </tr>

              </tbody>
            </table>
          </div>
          <hr class="padding-bottom-1x">
          <div class="d-flex justify-content-between"><router-link class="btn btn-outline-secondary m-0" to="/checkout">Back</router-link><router-link class="btn btn-primary m-0" to="/payment">Continue</router-link></div>
        </div>
        <!-- Sidebar          -->
        <div class="col-xl-3 col-lg-4">
          <aside class="sidebar">
            <div class="padding-top-2x hidden-lg-up"></div>
            <!-- Order Summary Widget-->
            <section class="widget widget-order-summary bg-secondary border-0 p-4">
              <h3 class="widget-title">Order Summary</h3>
              <table class="table text-sm mb-0">
                <tr>
                  <td>Cart Subtotal:</td>
                  <td class="text-medium">${{total}}</td>
                </tr>
                <tr>
                  <td>Shipping:</td>
                  <td class="text-medium">$0.00</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-lg text-medium">$665.32</td>
                </tr>
              </table>
            </section>

            <!-- Promo Banner-->
            <div class="fw-section mt-1 px-4 py-5 text-center" style="background-image: url(static/img/banners/alert-bg.jpg);">
              <h3 class="text-white">Check our <br><span class='text-bold'>Latest Offers.</span><br> Save up to <span class='text-bold'>50%</span></h3><a class="btn btn-primary btn-sm" href="#">View Offers</a>
            </div>
          </aside>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    total() {
      return this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
    },
    ...mapGetters({
      products: 'cartProducts'
    })
  }
};
</script>

<style scoped>
.page-title {
  margin-top: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/checkout/shipping.vue